import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  addArray as addUserGroupsArray,
  setOwnersLoadStatus,
  setUserOwners,
  setGroupOwners,
} from 'store/redux/userGroups'

export default function * fetchUserGroupOwners (action) {
  const { id } = action.payload

  const state = yield select()

  const userGroup = state.kanbo.userGroups[id]

  if (!userGroup) return

  yield put(setOwnersLoadStatus({
    id,
    loading: true,
    loaded: false
  }))

  try {
    const { Users, Groups } = yield call(apiGetData, 'GroupOwners', {
      groupId: id
    })

    const groups = []
    const groupIds = Groups.map(Group => {
      groups.push({
        id: Group.Id,
        name: Group.Name,
        description: Group.Description,
        internal: Group.Internal,
        external: Group.External,
      })

      return Group.Id
    })

    yield put([
      addUserGroupsArray(groups),
      setUserOwners({
        id,
        userIds: Users,
      }),
      setGroupOwners({
        id,
        groupIds,
      }),
      setOwnersLoadStatus({
        id,
        loading: false,
        loaded: true
      }),
    ])
  } catch (error) {
    yield put(setOwnersLoadStatus({
      id,
      loading: false,
      loaded: false
    }))

    throw error
  }
}
